<template>
    <v-card class="order-details-summary">
        <v-card-text class="order-details-summary-wrapper text-black text-subtitle-2">
            <v-row
                v-if="minDate || maxDate"
                class="order-details-summary__main-block justify-space-between flex-nowrap"
                style="gap: 10px"
                no-gutters
            >
                <span class="order-details-summary__main-label"> {{ $t('dates') }}: </span>
                <div class="order-details-summary__main-content text-end">
                    {{ $filters.dateFormat(minDate) }}
                    <span v-if="minDate !== maxDate"> - {{ $filters.dateFormat(maxDate) }}</span>
                </div>
            </v-row>
            <div v-if="duration" class="order-details-summary__main-content full-width text-end">
                {{ duration }}
            </div>
        </v-card-text>
    </v-card>
</template>
<script lang="ts">
    import {Component} from 'vue-facing-decorator'
    import {OrderDetailsSummary as _OrderDetailsSummary} from '~/components/account/OrderDetailsSummary.vue'

    @Component
    export class OrderDetailsTripAssistantSummary extends _OrderDetailsSummary {}
    export default OrderDetailsTripAssistantSummary
</script>
